import api from './index'

let exports = {};
//
exports.getServicerList = function (data, callback) {// 获取服务商列表
    api.post('/servicer/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
exports.getMerchantDtoList = function (data, callback) {// 获取服务商列表
    api.post('/servicer/merchant/dto/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
exports.getMerchantDtoListByIds = function (data, callback) {// 获取服务商列表
    api.post('/servicer/merchant/dto/list/get/by/ids')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
exports.getMerchantDtoById = function (data, callback) {// 获取服务商
    api.post('/servicer/merchant/dto/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

exports.getServicerListByRelevanceContract = function (data, callback) {// 获取关联当前零售商履约中合同的服务商列表
    api.post('/servicer/relevance/retail/contract/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 获取没有关联过的服务商列表
exports.getUnRelServicerList = function (data, callback) {// 获取没有关联过的服务商列表
    api.post('/servicer/list/un/rel/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

exports.getServicerEngineerListForSelected = function (params, callback) {// 获取服务商工程师列表（选择列表）
    api.post('/servicer/engineer/list/get/for/selected')
    .data(params)
    .done(callback)
    .go();
};

// 获取公司列表
exports.getServicerComListByMerchantId = function (params, callback) {// 获取服务商公司信息
    api.post('/servicer/list/get/by/merchantId')
    .data(params)
    .done(callback)
    .go();
};
export default exports;



//////////////////
// WEBPACK FOOTER
// ./src/api/servicer.js
// module id = 85
// module chunks = 0